<template>
  <el-button type="primary" plain v-if="hasBtn" @click="goBinding()"
    >用户绑定</el-button
  >
</template>

<script>
export default {
  props: {
    hasBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBinding() {
      // this.$router.push('/binding')
      console.log("用户绑定");
    },
  },
};
</script>